export function CogFillIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M13.621 2.57a2.5 2.5 0 00-3.243 0L8.813 3.905a.5.5 0 01-.284.118l-2.05.164a2.5 2.5 0 00-2.293 2.293l-.164 2.05a.5.5 0 01-.118.284l-1.333 1.565a2.5 2.5 0 000 3.243l1.333 1.566a.5.5 0 01.118.284l.164 2.05a2.5 2.5 0 002.293 2.293l2.05.164a.5.5 0 01.284.118l1.565 1.333a2.5 2.5 0 003.243 0l1.566-1.333a.5.5 0 01.284-.118l2.05-.164a2.5 2.5 0 002.293-2.293l.164-2.05a.5.5 0 01.118-.284l1.333-1.566a2.5 2.5 0 000-3.243l-1.333-1.565a.5.5 0 01-.118-.284l-.164-2.05a2.5 2.5 0 00-2.293-2.293l-2.05-.164a.5.5 0 01-.284-.118L13.62 2.571zM12 9a3 3 0 100 6 3 3 0 000-6z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
